export enum JobStatus {
    CREATED = 'CREATED',
    ACCEPTED = 'ACCEPTED',
    DECLINED_BY_HAULER = 'DECLINED_BY_HAULER',
    CANCELLED_BY_HAULER = 'CANCELLED_BY_HAULER',
    COMPLETED = 'COMPLETED',
    HAULER_ARRIVING = 'HAULER_ARRIVING',
    CONFIRM_ARRIVAL = 'CONFIRM_ARRIVAL',
    DECLINED_BY_CUSTOMER = 'DECLINED_BY_CUSTOMER',
    DECLINED_AUTO = 'DECLINED_AUTO',
    CANCELLED_BY_CUSTOMER = 'CANCELLED_BY_CUSTOMER',
    UNDER_REVIEW = 'UNDER_REVIEW',
    REVIEW_ACCEPTED = 'REVIEW_ACCEPTED',
    REVIEW_DECLINED = 'REVIEW_DECLINED',
    WAITING_FOR_PAYMENT_AUTHORIZATION = 'WAITING_FOR_PAYMENT_AUTHORIZATION',
    BIDDING_ACTIVE = 'BIDDING_ACTIVE',
    BIDS_AWAITING_ACCEPTANCE = 'BIDS_AWAITING_ACCEPTANCE',
    PAYMENT_ERROR = 'PAYMENT_ERROR'
}



// WEBPACK FOOTER //
// ./src/types/enums/JobStatus.ts